import { useStaticQuery, graphql } from 'gatsby'

export const queryEvents = () => {
  const query = useStaticQuery(
    graphql`
      {
        sanityEvent {
          id
          internal {
            type
            content
            contentDigest
            owner
          }
        }
      }
    `
  )
  return JSON.parse(query.sanityEvent.internal.content)
}
